export const MIN_CARD_HEIGHT = 412;
export const CARD_MARGIN_RIGHT = 18;
export const CARD_COLUMN_WIDTH = 242;
export const SIMPLIFIED_MIN_SIMPLIFIED_CARD_HEIGHT = 220;
export const SIMPLIFIED_MIN_SIMPLIFIED_CARD_WIDTH = 180;
export const SIMPLIFIED_CARD_IMAGE_HEIGHT = 110;
export const SIMPLIFIED_CARD_IMAGE_WIDTH = 180;
